/**
 * en-GB messages added by Phase 2 task S16 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s16EnGB = {
    'members.onboarding.default_subject': 'Welcome to {tenant}',
    'members.onboarding.default_body': '<p>Hello {{person.first_name}},</p><p>Welcome to {{tenant.name}}. Your start date is {{member.start_date}}.</p><p>Show this code to sign in:</p><p>{{member.qr}}</p>',
    'members.onboarding.qr_alt': 'Your sign-in QR code',
    'members.onboarding.app_link': 'Set up the app:',
    'error.onboarding_off': 'Onboarding emails are switched off for this group.',
    'error.onboarding_no_email': 'This member has no email address.',
    'error.onboarding_not_current': 'Only current members can be sent the onboarding email.',
    'error.onboarding_already_sent': 'The onboarding email has already been sent.',
};
//# sourceMappingURL=s16.js.map